import { koComponent } from '../ko-utils';

class NoData {
    constructor(params) {
        this.hint = params.hint;

        this.docsLink = params.docsLink;
        this.docsText = params.docsText;

        this.actionLink = params.actionLink;
        this.actionText = params.actionText;

        this.fullDocsLink = ko.pureComputed(() => {
            return `https://help.productfruits.com${ko.unwrap(this.docsLink)}`;
        });

        const specialLinks = {
            '[announcements]': () => `/${window.auth.project.UniqueCode}/announcements/overview`,
            '[contexthelps]': () => `/${window.auth.project.UniqueCode}/contexthelp/overview`,
            '[tours]': () => `/${window.auth.project.UniqueCode}/tours/overview`,
        };

        this.actionFullLink = ko.pureComputed(() => {
            const val = ko.unwrap(this.actionLink);
            const specialLink = specialLinks[val];

            return specialLink ? specialLink() : val;
        });
    }
}

export default koComponent('no-data', NoData);